export default __webpack_public_path__ + "static/media/blog7_image.d6070c90.png";